<template>
  <v-card class="text-center service-status-widget">
    <div class="text-uppercase text-h6 disabled" v-if="this.disabled">
      {{ $t("machines.dataTable.headers.serviceStatus") }}
    </div>

    <div v-else class="bg-secondary text-uppercase text-h6">
      {{ $t("machines.dataTable.headers.serviceStatus") }}
    </div>

    <v-card-text class="widget-body pa-0 d-flex justify-center align-center">
      <v-icon
        class="widget-icon"
        v-if="!this.disabled && !showIconAtRight"
        :color="iconColor"
      >
        {{ backgroundIcon }}
      </v-icon>

      <div class="widget-data">
        <div
          v-for="service in services"
          :key="service.key"
          cols="12"
          :md="12 / services.length"
          :class="'service-data'"
        >
          <div class="text-black text-uppercase text-h4">
            {{ service.scheduled }}
          </div>
          <div class="text-primary">
            {{ service.name }}
          </div>
          <div class="service-status-chip">
            <v-chip
              size="small"
              :color="getStatusColor(service.status)"
              variant="flat"
            >
              {{ service.status.toUpperCase() }}
            </v-chip>
          </div>
        </div>
        <v-icon
          v-if="!disabled && showIconAtRight"
          :color="iconColor"
          class="widget-icon widget-icon-right"
        >
          {{ backgroundIcon }}
        </v-icon>
      </div>

      <v-btn
        v-if="actionLink && actionIcon && !this.disabled"
        class="widget-action-button"
        variant="flat"
        size="small"
        :to="{ path: actionLink }"
        :icon="actionIcon"
      >
      </v-btn>
    </v-card-text>

    <v-overlay
      v-if="this.disabled"
      :model-value="true"
      contained
      persistent
      scrim="#fff"
      style="--v-overlay-opacity: 0.9"
      class="align-center text-primary"
    >
      <h1 class="text-h6 d-flex mb-5">
        <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
        {{ $t("machines.featureNotAvailable") }}
      </h1>
    </v-overlay>
  </v-card>
</template>

<script>
export default {
  props: {
    upcoming: { type: Array, required: true },
    actionLink: { type: String },
    actionIcon: { type: String },
    disabled: { type: Boolean },
    backgroundIcon: { type: String },
    backgroundIconColor: { type: String },
  },
  created() {},
  computed: {
    showIconAtRight() {
      return this.services?.length === 1 && this.backgroundIcon !== "mdi-wrench"
    },
    iconColor() {
      if (
        this.backgroundIconColor !== undefined &&
        this.backgroundIconColor !== null
      ) {
        return this.backgroundIconColor
      }
      return "text-grey-lighten-3"
    },

    services() {
      return this.upcoming.map((service, index) => {
        let svc = {
          key: `${service.step}-${index}`,
          name: `${this.$t("machines.service")} ${service.number}`,
          status: service.status,
        }

        if (service.status !== "upcoming") {
          svc.scheduled = this.$t("common.enums.day.now")
          return svc
        }

        let scheduled = []
        if (service.remainingHours !== null) {
          scheduled.push(
            `${service.remainingHours} ${this.$t("common.units.hourShort")}`
          )
        }

        if (service.remainingDays !== null) {
          scheduled.push(this.$t("common.units.day", service.remainingDays))
        }

        svc.scheduled = scheduled.join(" / ")

        return svc
      })
    },
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case "upcoming":
          return "grey"
        case "pending":
          return "orange"
        case "completed":
          return "green"
        case "overdue":
          return "red"
      }

      return null
    },
  },
}
</script>

<style scoped>
.widget-body {
  position: relative;
  min-height: 220px;
}
.widget-icon {
  position: absolute;
  font-size: 10em;
}

.widget-icon-right {
  position: static;
}
.widget-container-left {
  margin-right: 15em;
}

.widget-container-center {
  display: flex;
  flex-direction: column;
}

.service-data {
  display: flex;
  flex-direction: column;
}

.widget-data {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  z-index: 200;
}

:deep(.widget-action-button) {
  margin: 0.5rem;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 201;
}

.disabled {
  background-color: #eceff1;
}
</style>
